/*
 * Hunny Group — Smooth Scroll
 * Add this file to assets/ and include in theme.liquid:
 * {{ 'hunny-smooth-scroll.js' | asset_url | script_tag }}
 *
 * Usage: Add links like href="#about" in the drawer menu.
 * Each section needs a matching id, e.g. id="about"
 *
 * To add fixed IDs to each section, add a "Custom ID" text field
 * in each section's schema, or simply add an anchor div above each section.
 */

(function () {
  'use strict';

  /* ═══ Config ═══ */
  const SCROLL_DURATION = 900; /* ms */
  const OFFSET = 20; /* px from top — increase if you have a sticky header */

  /* ═══ Easing: easeInOutCubic ═══ */
  function easeInOutCubic(t) {
    return t < 0.5
      ? 4 * t * t * t
      : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  /* ═══ Smooth scroll to target ═══ */
  function smoothScrollTo(targetEl) {
    const startY = window.pageYOffset;
    const targetY = targetEl.getBoundingClientRect().top + startY - OFFSET;
    const distance = targetY - startY;
    const startTime = performance.now();

    function step(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / SCROLL_DURATION, 1);
      const easedProgress = easeInOutCubic(progress);

      window.scrollTo(0, startY + distance * easedProgress);

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  /* ═══ Close any open drawer ═══ */
  function closeDrawer() {
    const drawer = document.querySelector('[data-drawer]');
    const overlay = document.querySelector('[data-drawer-overlay]');
    const toggle = document.querySelector('[data-drawer-toggle]');

    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    if (toggle) toggle.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  /* ═══ Intercept anchor clicks ═══ */
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href*="#"]');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href || href === '#') return;

    /* Extract the hash */
    let hash;
    try {
      const url = new URL(href, window.location.origin);
      /* Only handle same-page anchors */
      if (url.pathname !== window.location.pathname && url.pathname !== '/') return;
      hash = url.hash;
    } catch (err) {
      /* Fallback for simple #hash links */
      if (href.startsWith('#')) {
        hash = href;
      } else {
        return;
      }
    }

    if (!hash || hash === '#') return;

    const targetEl = document.querySelector(hash);
    if (!targetEl) return;

    e.preventDefault();

    /* Close drawer first, then scroll after a brief delay */
    closeDrawer();

    setTimeout(function () {
      smoothScrollTo(targetEl);
    }, 150);

    /* Update URL hash without jumping */
    if (history.pushState) {
      history.pushState(null, null, hash);
    }
  });
})();
